"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCallBridge = void 0;
const errors_1 = require("./errors");
function isBridgeAvailable(bridge) {
    return !!(bridge === null || bridge === void 0 ? void 0 : bridge.callBridge);
}
const getCallBridge = () => {
    if (!isBridgeAvailable(window.__bridge)) {
        throw new errors_1.BridgeAPIError(`
      Unable to establish a connection with the Custom UI bridge.
      If you are trying to run your app locally, Forge apps only work in the context of Atlassian products. Refer to https://go.atlassian.com/forge-tunneling-with-custom-ui for how to tunnel when using a local development server.
    `);
    }
    return window.__bridge.callBridge;
};
exports.getCallBridge = getCallBridge;
